// https://www.ag-grid.com/react-data-grid/localisation/
import { AG_GRID_LOCALE_FI, AG_GRID_LOCALE_EN, AG_GRID_LOCALE_SE, AG_GRID_LOCALE_NL } from "@ag-grid-community/locale";

// https://www.ag-grid.com/charts/react/localisation/
// already done in utils.jsx - localized.agChartsLocale

const gridLocales = {
  "fi": AG_GRID_LOCALE_FI,
  "en": AG_GRID_LOCALE_EN,
  "sv": AG_GRID_LOCALE_SE,
  "nl": AG_GRID_LOCALE_NL,
};
export const localeText = i18n => {
  return gridLocales[i18n.resolvedLanguage];
};

// TODO: if translation key is not found with getLocaleText use translation from ag-grid/charts/locale
export const getLocaleText = (t, params) => {
  return t(params.key, {ns: "grid"});
};

export const resetSorting = gridRef => {
  gridRef.current.api.applyColumnState({
    defaultState: { sort: null },
  });
};

export const onGridReady = (datasource, params) => {
  params.api.setServerSideDatasource(datasource);
};

export const onPageSizeChanged = (gridRef, datasource, e) => {
  let newPageSize = 0;
  if (e.target.value === "ALL") {
    newPageSize = gridRef.current.api.paginationGetRowCount();
  } else {
    newPageSize = e.target.value;
  }
  gridRef.current.api.paginationSetPageSize(newPageSize);
  gridRef.current.api.gridOptionsWrapper.setProperty("cacheBlockSize", newPageSize);
  // Datasource needs to be reset for new cacheBlockSize to take effect
  gridRef.current.api.setServerSideDatasource(datasource);
};

export const onClientPageSizeChanged = (gridRef, e) => {
  let newPageSize = 0;
  if (e.target.value === "ALL") {
    newPageSize = gridRef.current.api.paginationGetRowCount();
  } else {
    newPageSize = e.target.value;
  }
  gridRef.current.api.paginationSetPageSize(newPageSize);
};

/*
// TODO: remove (unused)
export const dateFormatter = (t, params) => {
  if (params && params.value && params.value !== "") {
    return t("intlDateTime", { val: Date.parse(params.value)});
  } else {
    return "";
  }
};
*/

export const resetColumnsAndFilters = params => {
  params.api.resetColumnState();
  params.api.applyColumnState({
    defaultState: { sort: null },
  });
  params.api.setFilterModel(null);
};

export const addGridData = (gridRef, items, index) => {
  const addItems = [];
  items.forEach(function(item) {
    if (!gridRef.current.api.getRowNode(item.rowId)) {
      addItems.push(item);
    }
  });
  gridRef.current.api.applyTransaction({ add: addItems, addIndex: index });
};

export const updateGridData = (gridRef, items) => {
  const updateItems = [];
  items.forEach(function(item) {
    if (gridRef.current.api.getRowNode(item.rowId)) {
      updateItems.push(item);
    }
  });
  gridRef.current.api.applyTransaction({ update: updateItems });
};

export const removeGridData = (gridRef, items) => {
  const deleteItems = [];
  items.forEach(function(item) {
    if (gridRef.current.api.getRowNode(item.rowId)) {
      deleteItems.push(item);
    }
  });
  gridRef.current.api.applyTransaction({ remove: deleteItems });
};
